// extracted by mini-css-extract-plugin
module.exports = {"patientName":"Table_patientName__2zv_Z","productName":"Table_productName__1Vfqk"};